import React, { useEffect, useState, useContext } from 'react';
import './object.css';
import axios from 'axios';
import { LanguageContext } from "../context/LanguageContext";

const CreateObjectStep3 = ({ formData, setFormData, onNext, onBack }) => {
  const API_URL = process.env.REACT_APP_API_URL;
  const { language, texts } = useContext(LanguageContext);

  // Sprache normalisieren
  const lang = (language || "de").split("-")[0];

  // States für alle Ausstattungskategorien
  const [amenitiesGeneral, setAmenitiesGeneral] = useState(formData.amenities_general || []);
  const [amenitiesOutdoor, setAmenitiesOutdoor] = useState(formData.amenities_outdoor || []);
  const [amenitiesEnvironment, setAmenitiesEnvironment] = useState(formData.amenities_environment || []);
  const [environmentCards, setEnvironmentCards] = useState(formData.environment || []);

  // Daten aus API
  const [amenitiesList, setAmenitiesList] = useState({
    general: [],
    outdoor: [],
    environmentAmenities: [],
    environmentCards: []
  });

  const [error, setError] = useState(null);

  // API‑Daten laden
  useEffect(() => {
    const fetchAmenities = async () => {
      try {
        const [
          general,
          outdoor,
          environmentAmenities,
          environmentCards
        ] = await Promise.all([
          axios.get(`${API_URL}/api/amenities-general?lang=${lang}`),
          axios.get(`${API_URL}/api/amenities-outdoor?lang=${lang}`),
          axios.get(`${API_URL}/api/environment-amenities?lang=${lang}`),
          axios.get(`${API_URL}/api/environments?lang=${lang}`)
        ]);

        setAmenitiesList({
          general: general.data,
          outdoor: outdoor.data,
          environmentAmenities: environmentAmenities.data,
          environmentCards: environmentCards.data
        });
      } catch (err) {
        console.error("Fehler beim Laden der Ausstattung:", err);
        setError(texts.object.step3.errorLoading);
      }
    };

    fetchAmenities();
  }, [API_URL, lang, texts]);

  // Checkbox‑Toggle
  const toggleAmenity = (setter, current, id) => {
    setter(
      current.includes(id)
        ? current.filter(item => item !== id)
        : [...current, id]
    );
  };

  // Umgebung (Karten)
  const toggleEnvironmentCard = (id) => {
    setEnvironmentCards(prev =>
      prev.includes(id.toString())
        ? prev.filter(item => item !== id.toString())
        : [...prev, id.toString()]
    );
  };

  // FormData synchronisieren
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      amenities_general: amenitiesGeneral,
      amenities_outdoor: amenitiesOutdoor,
      amenities_environment: amenitiesEnvironment,
      environment: environmentCards
    }));
  }, [
    amenitiesGeneral,
    amenitiesOutdoor,
    amenitiesEnvironment,
    environmentCards,
    setFormData
  ]);

  return (
    <div className="object-form-container">
      <h2 className="object-header">{texts.object.step3.title}</h2>

      {error && <div className="error-message">{error}</div>}

      <div className="object-content-scroll-area">
        <div className="form-cards">
          <div className="amenities-container">

            {/* Allgemeine Ausstattung */}
            <div className="amenity-card">
              <h3>{texts.object.step3.general}</h3>
              <div className="checkbox-list">
                {amenitiesList.general.map(item => (
                  <label key={item.id} className="object-checkbox-item">
                    <input
                      type="checkbox"
                      checked={amenitiesGeneral.includes(item.id)}
                      onChange={() =>
                        toggleAmenity(setAmenitiesGeneral, amenitiesGeneral, item.id)
                      }
                    />
                    {item.name}
                  </label>
                ))}
              </div>
            </div>

            {/* Außenbereich */}
            <div className="amenity-card">
              <h3>{texts.object.step3.outdoor}</h3>
              <div className="checkbox-list">
                {amenitiesList.outdoor.map(item => (
                  <label key={item.id} className="object-checkbox-item">
                    <input
                      type="checkbox"
                      checked={amenitiesOutdoor.includes(item.id)}
                      onChange={() =>
                        toggleAmenity(setAmenitiesOutdoor, amenitiesOutdoor, item.id)
                      }
                    />
                    {item.name}
                  </label>
                ))}
              </div>
            </div>

            {/* Umgebung – Checkbox */}
            <div className="amenity-card">
              <h3>{texts.object.step3.environmentAmenities}</h3>
              <div className="checkbox-list">
                {amenitiesList.environmentAmenities.map(item => (
                  <label key={item.id} className="object-checkbox-item">
                    <input
                      type="checkbox"
                      checked={amenitiesEnvironment.includes(item.id)}
                      onChange={() =>
                        toggleAmenity(
                          setAmenitiesEnvironment,
                          amenitiesEnvironment,
                          item.id
                        )
                      }
                    />
                    {item.name}
                  </label>
                ))}
              </div>
            </div>

            {/* Umgebung – Karten */}
            <div className="amenity-card">
              <h3>{texts.object.step3.environmentCards}</h3>
              <div className="checkbox-list">
                {amenitiesList.environmentCards.map(env => (
                  <label key={env.id} className="object-checkbox-item">
                    <input
                      type="checkbox"
                      checked={environmentCards.includes(env.id.toString())}
                      onChange={() => toggleEnvironmentCard(env.id)}
                    />
                    {env.name}
                  </label>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateObjectStep3;
